import marlinsEnglishTestDetailsLocale from './en.json'

const en = {
  marlinsEnglishTestDetails: marlinsEnglishTestDetailsLocale,
}

export default en
